"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.executeSafePromise = void 0;
const Logger_1 = require("./Logger");
const logger = new Logger_1.Logger(module);
/**
 * Execute a promise that should never reject. If it does, log the error and exit the process.
 * To be used in places where we want to "annotate" that the intention of a promise is never
 * to reject (unless something is really wrong).
 */
const executeSafePromise = async (createPromise) => {
    try {
        return await createPromise();
    }
    catch (err) {
        logger.fatal('Assertion failure!', { message: err?.message, err });
        if (process.exit !== undefined) {
            process.exit(1);
        }
        else {
            // cause an unhandled promise rejection on purpose
            throw new Error('executeSafePromise: Assertion failure!', err);
        }
    }
};
exports.executeSafePromise = executeSafePromise;
//# sourceMappingURL=executeSafePromise.js.map